module.exports = __webpack_public_path__ + "img/pro-med.7918c580.png";